var map = {
	"./ara": [
		492,
		15
	],
	"./ara.ts": [
		492,
		15
	],
	"./chi": [
		493,
		21
	],
	"./chi.ts": [
		493,
		21
	],
	"./dan": [
		494,
		30
	],
	"./dan.ts": [
		494,
		30
	],
	"./dut": [
		495,
		31
	],
	"./dut.ts": [
		495,
		31
	],
	"./eng": [
		311
	],
	"./eng.ts": [
		311
	],
	"./fin": [
		496,
		16
	],
	"./fin.ts": [
		496,
		16
	],
	"./fre": [
		497,
		17
	],
	"./fre.ts": [
		497,
		17
	],
	"./ger": [
		498,
		18
	],
	"./ger.ts": [
		498,
		18
	],
	"./gre": [
		499,
		19
	],
	"./gre.ts": [
		499,
		19
	],
	"./ita": [
		500,
		20
	],
	"./ita.ts": [
		500,
		20
	],
	"./jpn": [
		501,
		22
	],
	"./jpn.ts": [
		501,
		22
	],
	"./nor": [
		502,
		23
	],
	"./nor.ts": [
		502,
		23
	],
	"./por": [
		503,
		24
	],
	"./por.ts": [
		503,
		24
	],
	"./rum": [
		504,
		25
	],
	"./rum.ts": [
		504,
		25
	],
	"./rus": [
		505,
		26
	],
	"./rus.ts": [
		505,
		26
	],
	"./spa": [
		506,
		27
	],
	"./spa.ts": [
		506,
		27
	],
	"./swe": [
		507,
		28
	],
	"./swe.ts": [
		507,
		28
	],
	"./tha": [
		508,
		29
	],
	"./tha.ts": [
		508,
		29
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = 716;
module.exports = webpackAsyncContext;